class ProductMedias extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this.swiperContainer = this;
    this.swiperWrapper = this.querySelector(".product-medias__container");
    this.swiperSlides = this.querySelectorAll(".product-medias img");
    this.isPhone = window.innerWidth < 990;

    this.init();
    window.addEventListener("resize", () => {
      this.init();
    });
  }

  init() {
    if (this.isPhone) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  initSwiper() {
    if (this.swiper == null) {
      this.swiperContainer.classList.add("swiper");
      this.swiperWrapper.classList.add("swiper-wrapper");

      let paginationDiv = document.createElement("div");
      paginationDiv.classList.add("swiper-pagination");
      this.swiperContainer.appendChild(paginationDiv);

      this.swiperSlides.forEach((slide) => {
        let div = document.createElement("div");
        div.classList.add("swiper-slide", "swiper-slide-item");

        if (this.classList.contains("product-medias--Bracelet")) {
          if (slide.classList.contains("selected")) {
            div.classList.add("selected");
          } else {
            div.classList.remove("swiper-slide");
            div.classList.remove("selected");
            div.classList.add("hidden");
          }
        }
        // insert slide img into div
        div.appendChild(slide);
        // insert div into swiper wrapper
        this.swiperWrapper.appendChild(div);
      });

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
      });
    }
  }

  destroySwiper() {
    if (this.swiper != null) {
      this.swiper.destroy();
      this.swiper = null;
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i].indexOf("swiper") > -1) {
          this.classList.remove(this.classList[i]);
        }
      }
    }
  }
}

customElements.define("product-medias", ProductMedias);
